export enum Environment {
  ThipDevelopment = 'dev.thip',
  Development = 'dev',
  Test = 'test',
  Acceptance = 'acc',
  Staging = 'stag',
  Production = 'production',
}
